import emailjs from '@emailjs/browser';

// CONFIGURATION
const SERVICE_ID = 'service_zt2u608';
export const TEMPLATE_ID_INFO = 'template_uuzxgib';
export const TEMPLATE_ID_REPAIR = 'template_mj91ctv';
const PUBLIC_KEY = 'itSb60Hedy226Wb9-';

// Initialize EmailJS
emailjs.init(PUBLIC_KEY);

/**
 * Sends an email using EmailJS.
 * 
 * @param {Object} formData - The data to send in the email.
 * @param {string} [customTemplateId] - Optional template ID override.
 * @returns {Promise<Object>}
 */
export const sendEmail = async (formData, customTemplateId) => {
    try {
        // Log parameters for debugging
        console.log('Building template params for:', customTemplateId || 'default');

        // Standardize parameters and ensure they are all strings or boolean
        const templateParams = {
            nome: String(formData.nome || '-'),
            azienda: String(formData.azienda || '-'),
            email: String(formData.email || '-'),
            telefono: String(formData.telefono || '-'),
            tipo: String(formData.tipo || formData.tipo_richiesta || 'Generica'),
            tipo_richiesta: String(formData.tipo_richiesta || formData.tipo || 'Generica'),
            messaggio: String(formData.messaggio || formData.problema || '-'),
            settore: String(formData.settore || '-'),
            marca: String(formData.marca || '-'),
            modello: String(formData.modello || '-'),
            avviso_urgenza: formData.urgente ? 'INTERVENTO URGENTE RICHIESTO!' : '',
            urgente: formData.urgente ? 'SÌ' : '', // Keep for compatibility

            // Legacy/Alias support
            message: String(formData.messaggio || formData.problema || '-'),
            from_name: String(formData.nome || '-')
        };

        console.log('Final template params:', templateParams);

        const response = await emailjs.send(
            SERVICE_ID,
            customTemplateId || TEMPLATE_ID_INFO,
            templateParams
        );

        console.log('Email sent successfully!', response.status, response.text);
        return { success: true };
    } catch (error) {
        console.error('Failed to send email:', error);
        return { success: false, error };
    }
};
